import { ImplementationDetailsTabs } from './pageComponents/implementation/ImplementationDetails'

export class AppRoutes {
  static readonly HOME = '/'
  static readonly ADMINISTRATION = '/Administration/:id'
  static readonly PLANNING = '/Planning'
  static readonly PLANNING_INSTANCE = '/Planning/:rcnId'
  static readonly PLANNING_DETAILS = '/Planning/:rcnId/:planId/:tab'
  static readonly PLANNING_PRIORITY_ACTIVITIES_PLAN_ORGANIZATION = '/Planning/:rcnId/:planId/:tab/PlanOrganization/:planOrgId'
  static readonly PLANNING_PRIORITY_ACTIVITIES_PLAN_ORGANIZATION_PRIORITY = '/Planning/:rcnId/:planId/:tab/PlanOrganization/:planOrgId/Priority/:planOrgTaskId'
  static readonly IMPLEMENTATION = '/Implementation'
  static readonly IMPLEMENTATION_INSTANCE = '/Implementation/:rcnId'
  static readonly IMPLEMENTATION_PROGRESSREPORTS = `/Implementation/:rcnId/:planId/${ImplementationDetailsTabs.ProgressReports}`
  static readonly IMPLEMENTATION_DETAILS = '/Implementation/:rcnId/:planId/:tab'
  static readonly IMPLEMENTATION_PRIORITY_ACTIVITIES_PLAN_ORGANIZATION = '/Implementation/:rcnId/:planId/:tab/PlanOrganization/:planOrgId'
  static readonly IMPLEMENTATION_PRIORITY_ACTIVITIES_PLAN_ORGANIZATION_PRIORITY = '/Implementation/:rcnId/:planId/:tab/PlanOrganization/:planOrgId/Priority/:planOrgTaskId'
  static readonly IMPLEMENTATION_CETA = '/Implementation/CETA/:timeSpanId'
  static readonly IMPLEMENTATION_PROGRESS_REPORTS_ORGANIZATION = '/Implementation/:rcnId/:planId/:tab/Organization/:orgId'
  static readonly ORGANIZATION_DETAILS = '/Organization/:id/:tab'
  static readonly RESOURCES = '/Resources'
  static readonly REPORTS = '/Reports'
  static readonly USER_DETAILS = '/User/:userId/:orgId?'
  static readonly CETA_CLASSROOMS = '/CETAClassrooms/:timeSpanId/:classroomId?'
  static readonly CETA_OVERVIEW = '/CETAOverview/:classroomId/:tab'
  static readonly CETA_SECTION_PRINT = '/CETAPlan/PrintSections/:classroomId/:tab/:sectionIds'
  static readonly CETA_SNAPSHOT = '/CETA/:classroomId/Snapshot/:snapshotId'
  static readonly CETA_RECONCILE = '/CETA/:classroomId/Reconcile/:snapshotId'
  static readonly USER_PROFILE = '/UserProfile'
}

export function getRouteFromString (name: string): string {
  switch (name) {
    case 'HOME': {
      return AppRoutes.HOME
    }
    case 'PLANNING': {
      return AppRoutes.PLANNING
    }
    case 'IMPLEMENTATION': {
      return AppRoutes.IMPLEMENTATION
    }
    case 'RESOURCES': {
      return AppRoutes.RESOURCES
    }
    case 'REPORTS': {
      return AppRoutes.REPORTS
    }
    default: {
      return AppRoutes.HOME
    }
  }
}
